module.exports = __webpack_public_path__ + "static/img/best_picture_02.af7c55d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/best_picture_02.jpg
// module id = 348
// module chunks = 0